module.exports = __webpack_public_path__ + "img/BG_brown.91bad1f4.jpg";